import { groupBy, isNil, sumBy } from 'lodash';
import type { OrderProject, ProjectProduct } from 'models/order/orderProject';

export interface MarkupTotals {
  user: number;
  other: number;
  total: number;
}

export const removeProduct = (
  project: OrderProject,
  productId: number
): OrderProject | undefined => replaceProduct(project, productId);

export const addProducts = (
  project: OrderProject,
  newProducts: ProjectProduct[]
): OrderProject | undefined => {
  if (isNil(project)) return;

  project.orderProducts = [...project.orderProducts, ...newProducts];

  return project;
};

export const replaceProduct = (
  project: OrderProject,
  productId: number,
  newProduct?: ProjectProduct
): OrderProject | undefined => {
  if (isNil(project)) return;

  const productIndex = project.orderProducts.findIndex((p) => p.id === productId);

  if (productIndex < 0) return;

  project.orderProducts = project.orderProducts.filter((_, i) => i !== productIndex);

  if (!isNil(newProduct)) {
    project.orderProducts = [
      ...project.orderProducts.slice(0, productIndex),
      newProduct,
      ...project.orderProducts.slice(productIndex),
    ];
  }

  return project;
};

export const getTotalMarkupForUser = (
  products: ProjectProduct[],
  userId: number
): MarkupTotals =>
  products.reduce<MarkupTotals>(
    (acc, v) => {
      const groups = groupBy(v.markups, (m) => m.userId === userId);
      const user = sumBy(groups.true, (m) => m.amountPerItem * v.count);
      const other = sumBy(groups.false, (m) => m.amountPerItem * v.count);

      acc.user += user;
      acc.other += other;
      acc.total += user + other;

      return acc;
    },
    { user: 0, other: 0, total: 0 }
  );
